import CustomerAcceptedTemplate from './customerAccepted.modal.html';

class FinanceConcludeController {
  constructor(enums, $scope, $uibModal, $ngConfirm, growl) {
    "ngInject";

    this.enums = enums;
    this.$scope = $scope;
    this.$uibModal = $uibModal;
    this.$ngConfirm = $ngConfirm;
    this.growl = growl;

    this.states = {};
    this.statusText = '';

    this.dtPopups = {}; //Cleanup

    this.$scope.$on('finance:initialized', this.setStateVisibility.bind(this));
  }

  resetStateVisibility() {
    this.states = {
      awaitingApproval: false,
      financeAccepted: false,
      financeRejected: false,
      customerAccepted: false,
      customerRejected: false
    };
  }

  setStateVisibility() {
    this.resetStateVisibility();

    switch(this.finance.state){
      case this.enums.FINANCE_STATE.Awaiting_Approval:
        this.states.financeAccepted = true;
        this.states.financeRejected = true;

        this.statusText = 'Awaiting Approval';
        break;

      case this.enums.FINANCE_STATE.Finance_Accepted:
        this.states.customerAccepted = true;
        this.states.customerRejected = true;

        this.statusText = 'Finance Accepted';
        break;

      case this.enums.FINANCE_STATE.Finance_Rejected:
        this.states.awaitingApproval = true;

        this.statusText = 'Finance Rejected';
        break;

      case this.enums.FINANCE_STATE.Customer_Accepted:
        this.statusText = 'Customer Accepted';

        this.states.customerRejected = true;
        break;

      case this.enums.FINANCE_STATE.Customer_Rejected:
        this.statusText = 'Customer Rejected';
        break;
    }
  }

  updateState(newState){
    if (newState === this.enums.FINANCE_STATE.Finance_Accepted && !this.finance.selectedOption){
      this.growl.error('Please provide at least one finance option first', {ttl: 5000});
      return;
    }

    if (newState === this.enums.FINANCE_STATE.Customer_Accepted){
      this.showCustomerAccepted();
      return;
    }    

    this.$ngConfirm({
      title: 'Update Finance Status',
      content: `Are you sure you want to mark this deal as <br /> <b>${this.getStateText(newState)}</b>`,
      typeAnimation: false,
      columnClass: 'm',
      buttons: {
          yes: {
              text: 'Yes',
              btnClass: 'btn-primary',
              action: () => { 
                this.saveState(newState);
              }
          },
          no: {
            text: 'No',
            btnClass: 'btn-default',
            action: () => { }
        }          
      }
    });       
  }

  getStateText(state) {
    switch(state){
      case this.enums.FINANCE_STATE.Awaiting_Approval:
        return "Awaiting Approval";

      case this.enums.FINANCE_STATE.Finance_Accepted:
        return "Finance Accepted";

      case this.enums.FINANCE_STATE.Finance_Rejected:
        return "Finance Rejected";

      case this.enums.FINANCE_STATE.Customer_Accepted:
        return "Customer Accepted";

      case this.enums.FINANCE_STATE.Customer_Rejected:
        return "Customer Rejected";
    }
  }

  closeModal() {
    this.$uibModalInstance.close();
  }  

  showDatePopup(id) {
    this.dtPopups[id] = true;
  }  

  showCustomerAccepted() {
    this.errMsg = '';
    this.modalData = {
      commissionAchieved: this.finance.commissionAchieved,
      installmentStart: this.finance.installmentStart
    };

    this.modalInstance = this.$uibModal.open({
      template: CustomerAcceptedTemplate,
      scope: this.$scope
    });    
  }

  customerAccepted() {
    this.finance.commissionAchieved = this.modalData.commissionAchieved;
    this.finance.installmentStart = this.modalData.installmentStart;

    this.saveState(this.enums.FINANCE_STATE.Customer_Accepted)
    
    this.closeModal();
  }

  closeModal() {
    this.modalInstance.close();
  }

  saveState(newState) {
    this.finance.state = newState;

    this.$scope.$emit('saveFinance');

    this.setStateVisibility();
  }
}

export default FinanceConcludeController;



// WEBPACK FOOTER //
// ./client/app/components/finance/financeEdit/financeConclude/financeConclude.controller.js